import axiosRequest from "api";
import { isMobile } from "constants/common";
import { Device } from "enums/device";
import { payloadHelper } from "helpers/payload-helper";
import {
  CategoryDetailsResponseType,
  GetFavouriteGameResponse,
  LoginGameResponseType,
  LoginGameType,
  SubGamePayLoad,
  SubGameResponse,
  UpdateFavouriteGamePayload,
  UpdateFavouriteGameResponse,
} from "types/game";

export const gameApi = {
  loginGame: (username: string, payload: LoginGameType) =>
    axiosRequest.post<LoginGameResponseType>(
      "",
      payloadHelper(
        "LoginGame",
        username,
        payload,
        undefined,
        isMobile ? Device.MOBILE : Device.WEB,
      ),
      {
        cancelToken: payload.source?.token,
      },
    ),

  getSubGameList: (payload: SubGamePayLoad) =>
    axiosRequest.post<SubGameResponse>(
      "",
      payloadHelper("GetSubGameList", "", payload),
    ),

  getGameList: (game_type: string) =>
    axiosRequest.post<CategoryDetailsResponseType>(
      "",
      payloadHelper("GetGameList", game_type, { game_type }),
    ),

  async updateMemberFavouriteGame(payload: UpdateFavouriteGamePayload) {
    const { data } = await axiosRequest.post<UpdateFavouriteGameResponse>(
      "/",
      payloadHelper("UpdateFavourite", payload.username, payload),
    );
    return data;
  },

  async getMemberFavouriteGame(username: string) {
    const { data } = await axiosRequest.post<GetFavouriteGameResponse>(
      "/",
      payloadHelper("Favourite", username, { username }),
    );
    return data;
  },
};
